import React from "react";
import { motion } from "framer-motion";

const TIMELINE = [
  { y: "Now", t: "Building Parabolum — a boutique studio for serious software." },
  { y: "Before", t: "Years shipping products, platforms and automations end-to-end." },
  { y: "Always", t: "Learning fast, obsessing over execution and craft." },
];

const ease = [0.16, 1, 0.3, 1];

export default function Founder() {
  return (
    <section id="founder" className="relative bg-[var(--paper)] py-24 md:py-32">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <span className="label text-[var(--ink-soft)]">(06) — Why Parabolum</span>

        <div className="mt-10 grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-10">
          {/* portrait + timeline */}
          <div className="lg:col-span-4">
            <div className="relative aspect-[4/5] w-full max-w-sm overflow-hidden rounded-[32px] border border-[var(--line)] bg-[var(--paper-3)] shadow-soft">
              <img
                src="/founder.png"
                alt="Parabolum founder portrait"
                draggable="false"
                loading="lazy"
                className="absolute inset-0 h-full w-full select-none object-cover"
                style={{ filter: "grayscale(1) contrast(1.05)" }}
              />
              <div
                className="pointer-events-none absolute inset-0 mix-blend-screen opacity-30"
                style={{
                  background:
                    "radial-gradient(60% 50% at 70% 80%, rgba(228,255,0,0.30), transparent 60%)",
                }}
              />
              <div
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0) 55%, rgba(0,0,0,0.55) 100%)",
                }}
              />
              <span className="absolute right-6 top-6 rounded-full border border-white/20 bg-black/30 px-3 py-1 text-[11px] uppercase tracking-widest text-white/85 backdrop-blur-sm">
                Founder
              </span>
            </div>

            <div className="mt-10 space-y-5">
              {TIMELINE.map((item) => (
                <div key={item.y} className="flex gap-5">
                  <span className="label w-14 shrink-0 pt-1 text-[var(--ink-faint)]">
                    {item.y}
                  </span>
                  <p className="text-[14px] leading-relaxed text-[var(--ink-soft)]">
                    {item.t}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* statement */}
          <div className="lg:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease }}
              className="ff-display text-4xl font-extrabold leading-[1.02] tracking-tight md:text-6xl"
            >
              WHY
              <br />
              PARABOLUM
            </motion.h2>

            <div className="mt-10 max-w-2xl space-y-7 text-2xl leading-[1.35] tracking-tight text-[var(--ink)] md:text-[32px]">
              <p>
                I don&apos;t claim to know everything. I simply enjoy building
                products, learning quickly and solving problems.
              </p>
              <p className="text-[var(--ink-soft)]">
                I believe{" "}
                <span className="ff-serif text-[var(--ink)]">execution</span>{" "}
                matters more than titles.
              </p>
            </div>

            <div className="mt-12 h-px w-full bg-[var(--line)]" />
            <div className="mt-7 grid grid-cols-2 gap-6 sm:grid-cols-4">
              {[
                ["Direct", "with the builder"],
                ["Fast", "decisions, no layers"],
                ["Honest", "about scope & time"],
                ["Obsessed", "with the details"],
              ].map(([a, b]) => (
                <div key={a}>
                  <div className="ff-display text-xl font-bold tracking-tight">{a}</div>
                  <div className="mt-1 text-[13px] text-[var(--ink-soft)]">{b}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
